import { DlUnit } from "model/dl_unit/DlUnit";
import { useParams } from "react-router-dom";
import { useUnitGet } from "../useUnitGet";

export const useUnitFromPathSlug = (): DlUnit | null => {
  const { slug } = useParams();
  const unit = useUnitGet(slug as string, "slug");

  return unit;
};
